import React, { useState } from "react";
import { Accordion, Form, Button } from "react-bootstrap";

const PastRecordings = ({
  pastWithRecording = [],
  selectedCourse = "All",
  handleVideoClick = (url) => window.open(url, "_blank", "noopener,noreferrer"),
  formatSessionTime = (date, time, tz) => ({
    formattedDate: date,
    formattedRange: time,
  }),
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const userTz = localStorage.getItem("userTimezone") || "Asia/Kolkata";

  // Group sessions by Term first, then by CourseId
  const groupedByTerm = pastWithRecording
    .filter((s) => selectedCourse === "All" || s.CourseId === selectedCourse)
    .filter((s) => s.Class.toLowerCase().includes(searchTerm.toLowerCase()))
    .reduce((termGroups, session) => {
      const term = session.Term || "Unknown Term";
      if (!termGroups[term]) termGroups[term] = {};
      const courseId = session.CourseId || "Unknown Course";
      if (!termGroups[term][courseId]) termGroups[term][courseId] = [];
      termGroups[term][courseId].push(session);
      return termGroups;
    }, {});

  // Natural sort for terms like "Year-1-Term-2" < "Year-1-Term-10"
  const termKeys = Object.keys(groupedByTerm).sort((a, b) => {
    const termRegex = /Year-(\d+)-Term-(\d+)/i;
    const matchA = a.match(termRegex);
    const matchB = b.match(termRegex);

    if (matchA && matchB) {
      const yearDiff = parseInt(matchA[1]) - parseInt(matchB[1]);
      if (yearDiff !== 0) return yearDiff;
      return parseInt(matchA[2]) - parseInt(matchB[2]);
    }
    return a.localeCompare(b); // fallback
  });

  // The last term in natural order is the latest
  const latestTerm = termKeys[termKeys.length - 1];

  return (
    <div className="mt-4">
      <h5>Past Recordings</h5>

      {pastWithRecording.length === 0 ? (
        <p>No recordings available.</p>
      ) : (
        <>
          <Form.Control
            type="text"
            placeholder="Search by class name..."
            className="my-3"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <Accordion defaultActiveKey={latestTerm}>
            {termKeys.map((term) => (
              <Accordion.Item eventKey={term} key={term}>
                <Accordion.Header>{term}</Accordion.Header>
                <Accordion.Body>
                  <Accordion>
                    {Object.keys(groupedByTerm[term]).map((courseId) => (
                      <Accordion.Item eventKey={courseId} key={courseId}>
                        <Accordion.Header>{courseId}</Accordion.Header>
                        <Accordion.Body>
                          {groupedByTerm[term][courseId].map((s, i) => {
                            const { formattedDate, formattedRange } =
                              formatSessionTime(s.Date, s.Time, userTz);

                            return (
                              <div key={i} className="mb-3">
                                <strong>{s.Class}</strong>
                                <br />
                                <small>
                                  {formattedDate} | {formattedRange}
                                </small>
                                <br />
                                <Button
                                  size="sm"
                                  variant="outline-primary"
                                  onClick={() => handleVideoClick(s.RecordingLink)}
                                >
                                  Watch
                                </Button>
                              </div>
                            );
                          })}
                        </Accordion.Body>
                      </Accordion.Item>
                    ))}
                  </Accordion>
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </>
      )}
    </div>
  );
};

export default PastRecordings;
